/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FailureStatusRuleVm,
    FailureStatusRuleVmFromJSON,
    FailureStatusRuleVmFromJSONTyped,
    FailureStatusRuleVmToJSON,
    SimpleFailureStatusVm,
    SimpleFailureStatusVmFromJSON,
    SimpleFailureStatusVmFromJSONTyped,
    SimpleFailureStatusVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface FailureStatusRulesResponseVm
 */
export interface FailureStatusRulesResponseVm {
    /**
     * 
     * @type {Array<SimpleFailureStatusVm>}
     * @memberof FailureStatusRulesResponseVm
     */
    statuses?: Array<SimpleFailureStatusVm> | null;
    /**
     * 
     * @type {Array<FailureStatusRuleVm>}
     * @memberof FailureStatusRulesResponseVm
     */
    rules?: Array<FailureStatusRuleVm> | null;
}

export function FailureStatusRulesResponseVmFromJSON(json: any): FailureStatusRulesResponseVm {
    return FailureStatusRulesResponseVmFromJSONTyped(json, false);
}

export function FailureStatusRulesResponseVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureStatusRulesResponseVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statuses': !exists(json, 'statuses') ? undefined : (json['statuses'] === null ? null : (json['statuses'] as Array<any>).map(SimpleFailureStatusVmFromJSON)),
        'rules': !exists(json, 'rules') ? undefined : (json['rules'] === null ? null : (json['rules'] as Array<any>).map(FailureStatusRuleVmFromJSON)),
    };
}

export function FailureStatusRulesResponseVmToJSON(value?: FailureStatusRulesResponseVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statuses': value.statuses === undefined ? undefined : (value.statuses === null ? null : (value.statuses as Array<any>).map(SimpleFailureStatusVmToJSON)),
        'rules': value.rules === undefined ? undefined : (value.rules === null ? null : (value.rules as Array<any>).map(FailureStatusRuleVmToJSON)),
    };
}


